module.exports = __webpack_public_path__ + "static/media/pump.4cd0471b.png";